/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs */

const en_cv_extract_form_enum_arts_music_design_fashion22 = /** @type {(inputs: Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arts, Music, Design and Fashion`)
};

const de_cv_extract_form_enum_arts_music_design_fashion22 = /** @type {(inputs: Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst, Musik, Design und Mode`)
};

/**
* | output |
* | --- |
* | "Arts, Music, Design and Fashion" |
*
* @param {Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_arts_music_design_fashion22 = /** @type {((inputs?: Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Arts_Music_Design_Fashion22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_arts_music_design_fashion22(inputs)
	return en_cv_extract_form_enum_arts_music_design_fashion22(inputs)
});
export { cv_extract_form_enum_arts_music_design_fashion22 as "cv_extract_form_enum_ARTS_MUSIC_DESIGN_FASHION" }